import React, {useContext, useState, useEffect} from 'react'
import {Button, Col, Row, Table} from "antd";
import {PurchaseContext} from "../../../context/PurchaseContext";
import PurchaseStock from "../table-components/PurchaseStock";
import PurchaseQuantity from "../table-components/PurchaseQuantity";
import PurchaseStockUnitPrice from "../table-components/PurchaseStockUnitPrice";
import PurchaseCurrency from "../table-components/PurchaseCurrency";
import PurchaseDiscount from "../table-components/PurchaseDiscount";
import PurchaseSupplier from "../table-components/PurchaseSupplier";
import PurchaseShippingDate from "../table-components/PurchaseShippingDate";
import PurchaseRowTotal from "../table-components/PurchaseRowTotal";
import PurchaseUnit from "../table-components/PurchaseUnit";
import DeleteRow from "../table-components/deleteRow";



const PurchaseCompleteTable = () => {
    const {purchaseItems, updateDeleteCount} = useContext(PurchaseContext)
    const [purchaseItemList, setPurchaseItemList] = purchaseItems
    const [delCount] = updateDeleteCount
    const [uniqueKey, setUniqueKey] = useState(0)
    const [dataSource, setDataSource] = useState([])

    useEffect(() => {
        if (purchaseItemList.length) {
            setUniqueKey(purchaseItemList.length)
        }
        setDataSource(purchaseItemList)
    }, [purchaseItemList])

    const columns = [
        {
            title: 'Tedarikçi',
            dataIndex: 'supplier',
            key: 'supplier',
            render: (t, r, i) => <PurchaseSupplier record={r} rowIndex={i} />
        },
        {
            title: 'Stok Adı',
            dataIndex: 'stock',
            key: 'stock',
            render: (t, r, i) => <PurchaseStock record={r} rowIndex={i} update={true}/>
        },
        {
            title: 'Birim',
            dataIndex: 'unit',
            key: 'unit',
            render: (t, r, i) => <PurchaseUnit record={r} rowIndex={i} />
        },
        {
            title: 'Miktar',
            dataIndex: 'quantity',
            key: 'quantity',
            render: (t, r, i) => <PurchaseQuantity record={r} rowIndex={i}/>
        },
        {
            title: 'Birim Fiyat',
            dataIndex: 'unitPrice',
            key: 'unitPrice',
            render: (t, r, i) => <PurchaseStockUnitPrice record={r} rowIndex={i}/>
        },
        {
            title: 'Para Birimi',
            dataIndex: 'currency',
            key: 'currency',
            render: (t, r, i) => <PurchaseCurrency record={r} rowIndex={i} />
        },
        {
            title: 'Iskonto %',
            dataIndex: 'discount',
            key: 'discount',
            render: (t, r, i) => <PurchaseDiscount record={r} rowIndex={i}/>
        },
        {
            title: 'Sevk Tarihi',
            dataIndex: 'shippingDate',
            key: 'shippingDate',
            render: (t, r, i) => <PurchaseShippingDate record={r} rowIndex={i} />
        },
        {
            title: 'Toplam',
            dataIndex: 'total',
            key: 'total',
            render: (t, r, i) => <PurchaseRowTotal rowIndex={i} record={r}/>
        },
        {
            title: 'işlemler',
            dataIndex: 'actions',
            key: 'actions',
            render: (t, r, i) => <DeleteRow record={r} rowIndex={i} />
        }
    ]

    const handleAddRow = () => {
        setPurchaseItemList([
            ...purchaseItemList,
            {
                key: uniqueKey + delCount,
                stock: '',
                quantity: '0',
                unit: '',
                currency: '',
                price: '0',
                shippingDate: ''
            }
        ])
        setUniqueKey((uniqueKey) => uniqueKey + 1 + delCount)
    }

    return (
        <React.Fragment>
            <Row justify={'start'}>
                <Col span={8}>
                    <Button type={'link'} onClick={handleAddRow}>Yeni Ekle</Button>
                </Col>
            </Row>
            <Table scroll={{x: 'max-content'}} pagination={false} columns={columns} dataSource={dataSource}/>
        </React.Fragment>
    )
}
export default PurchaseCompleteTable